export default {
  courses: [],
  authors: [],
  cities: [{ label: "Hela Sverige", value: "Hela Sverige" }],
  categories: [],
  targetGroups: [],
  foods: [],
  foodCost: [],
  events: [{ id: 0, name: "initial state" }],
  attending: { status: "initial state" },
  targetgroups: ["barn", "unga", "gamla", "trötta"],
  event: {},
  apiCallsinProgress: 0,
  date: new Date().toLocaleString(),
  selectedCity: "Hela Sverige",
  user: {},
  network: [{ id: 0, name: "initial state" }],
  profiles: [],
  reports: [],
  bibleVerse: {
    verse:
      "Sök först Guds rike och Hans rättfärighet, så skall ni få allt det andra också.",
    bibleRef: "Matt 6:33",
    bibleRefUrl: "https://www.bibeln.se/bibel/B2000/MAT.6.33",
    lastFetched: "2025-04-05 14:35:11"
  }
};
